export const MOCK_ASSET_DETAILS = {
  entity: {
    _schema: 'asset',
    _id: 'a1b2c3d4-0000-4000-8000-000000000001',
    _org: 'test-org',
    _created_at: '2025-06-01T10:00:00.000Z',
    _updated_at: '2026-01-15T14:30:00.000Z',
    _title: 'AS-100',
    _acl: {
      view: ['org_test-org'],
      edit: ['org_test-org'],
      delete: ['org_test-org']
    },
    // Asset Details
    asset_number: 'AS-100',
    asset_type: 'Wärmepumpe',
    title: 'Heat Pump Unit A',
    serial_number: 'SN-WP-20250601',
    manufacturer: 'Viessmann',
    model: 'Vitocal 250-A',
    manufacturing_date: '2024-11-01',
    beginn_widerrufsfrist: '2025-06-01',
    ende_widerrufsfrist: '2025-06-15',
    // Installation Details
    commissioning_date: '2025-06-15',
    installation_date: '2025-06-10',
    guarantee: 5,
    // Maintenance
    maintenance_date: '2025-12-01',
    upcoming_maintenance_date: '2026-12-01',
    // Relations
    customer: {
      $relation: [
        {
          entity_id: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
          _schema: 'contact'
        }
      ]
    },
    contract: {
      $relation: [
        {
          entity_id: 'a68e4801-979c-4fee-b43f-0dbacb06634e'
        }
      ]
    },
    meter: {
      $relation: [
        {
          entity_id: 'e250a873-fe35-4b24-b502-19a84347200d'
        }
      ]
    },
    installation_address: {
      $relation: [
        {
          entity_id: 'loc-0000-0000-0000-000000000001'
        }
      ]
    }
  },
  relations: []
}
